<template>
  <v-container grid-list-md>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <w-main-title
          class="pb-0"
          title="Revisa tus Promociones"
          :breadcrumbs="breadcrumbs"
        ></w-main-title>
      </v-flex>
      <v-flex xs12>
        <user-quotations :type="type"></user-quotations>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

export default {
  components: {
    WMainTitle: () => import('@/components/common/WMainTitle'),
    UserQuotations: () => import('@/components/panel-data/UserQuotations')
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Promociones',
          disabled: true,
          href: ''
        }
      ],
      type: 'special_sale' //special_sale - service
    }
  }
}
</script>
